<script lang="ts">
    import * as t from '$trans';
    import type { createDropdownMenu } from '@melt-ui/svelte';
    import type { NavbarQueryQuery } from '$gql/graphql';
    import { getContainer } from '$components/Context/ContainerContext';
    import entreprises_png from '$assets/super-app/entreprises_h128.png';
    import professionnels_png from '$assets/super-app/professionnels_h128.png';
    import { CountryNull } from '$lib/UrlHelper';
    import reseau_social_png from '$assets/super-app/reseau_social_h128.png';
    import messagerie_privee_png from '$assets/super-app/messagerie_privee_h128.png';
    import emploi_png from '$assets/super-app/emploi_h128.png';
    import medias_png from '$assets/super-app/medias_h128.png';
    import GridDropdown from '$components/Navbar/GridDropdown.svelte';
    import GridDropdownItem from '$components/Navbar/GridDropdownItem.svelte';

    export let meltMenu: ReturnType<typeof createDropdownMenu>;
    let item = meltMenu.elements.item;

    export let navbar: NavbarQueryQuery;

    const { urlHelper, lang } = getContainer();
</script>

<GridDropdown title={t.navbar.super_app({}, $lang)} nbCols={3}>
    <GridDropdownItem
        meltElement={$item}
        href={urlHelper().categories({ lang: $lang })}
        svelteKitReload={false}
        image={entreprises_png}
        label={t.navbar.super_app_company({}, $lang)}
    />
    <GridDropdownItem
        meltElement={$item}
        href={urlHelper().searchUsers({})}
        svelteKitReload={false}
        image={professionnels_png}
        label={t.navbar.super_app_pro({}, $lang)}
    />
    <GridDropdownItem
        meltElement={$item}
        href={navbar?.me == null
            ? urlHelper().servicePage('services_reseau_social_pro')
            : urlHelper().homepage({ _country: CountryNull })}
        image={reseau_social_png}
        label={t.navbar.super_app_social_network({}, $lang)}
        svelteKitReload={navbar?.me == null}
    />
    <GridDropdownItem
        meltElement={$item}
        href={navbar?.me == null
            ? urlHelper().servicePage('services_inbox')
            : urlHelper().inbox()}
        svelteKitReload={navbar.me == null}
        image={messagerie_privee_png}
        label={t.navbar.super_app_messaging({}, $lang)}
    />
    <GridDropdownItem
        meltElement={$item}
        href={urlHelper().searchJobs({})}
        image={emploi_png}
        label={t.navbar.super_app_job({}, $lang)}
    />
    <GridDropdownItem
        meltElement={$item}
        href={navbar.urls.cmsCountry}
        image={medias_png}
        label={t.navbar.super_app_media_cms({}, $lang)}
    />
</GridDropdown>
